import React from 'react';

import {BREAKPOINTS} from '../constants';

export type BreakpointContext = number;

export default React.createContext<BreakpointContext>(BREAKPOINTS.sm);
